module.exports = __webpack_public_path__ + "static/media/example-01.9b1b95e4.jpg";